export default class SizeTools {


  static addAllSizeSettings(resultOblect, userSettingsString, defaultSettingsString) {
    if (!userSettingsString && !defaultSettingsString) {
      return resultOblect
    }
    let sizeSettings = [
      { name: '--top-toolbar-btn-padding', index: 11, defaultValue: '10px', values: ['10px', '5px', '2px'], defValue: [0, 0, 0] },
      { name: '--context-menu-padding-top-bot', index: 11, defaultValue: '15px', values: ['15px', '10px', '8px'], defValue: [0, 0, 0] },
      { name: '--context-menu-font-size', index: 11, defaultValue: '16px', values: ['16px', '15px', '14px'], defValue: [0, 0, 0] },
      { name: '--frame-padding', index: 14, defaultValue: '15px', values: ['15px', '10px', '5px'], defValue: [0, 0, 0] },
      { name: '--top-toolbar-height', index: 15, defaultValue: '50px', values: ['50px', '40px', '32px'], defValue: [0, 0, 0] }, 
      { name: '--top-toolbar-full-logo-width', index: 15, defaultValue: '200px', values: ['200px', '160px', '160px'], defValue: [0, 0, 0] },
      { name: '--top-toolbar-logo-image-width', index: 15, defaultValue: '150px', values: ['150px', '122px', '113px'], defValue: [0, 0, 0] },
      { name: '--top-toolbar-logo-image-height', index: 15, defaultValue: '35px', values: ['35px', '26px', '22px'], defValue: [0, 0, 0] },
      { name: '--top-toolbar-user-photo-size', index: 15, defaultValue: '36px', values: ['36px', '36px', '30px'], defValue: [0, 0, 0] },
      { name: '--main-menu-width', index: 16, defaultValue: '400px', values: ['400px', '380px', '350px'], defValue: [0, 0, 0] },
      { name: '--main-menu-font-size', index: 16, defaultValue: '16px', values: ['16px', '15px', '14px'], defValue: [0, 0, 0] },
      { name: '--main-menu-treeview-item-padding-top-bot', index: 16, defaultValue: '10px', values: ['10px', '10px', '8px'], defValue: [0, 0, 0] },
      { name: '--dialog-button-height', index: 19, defaultValue: '36px', values: ['36px', '32px', '26px'], defValue: [0, 0, 0] }
    ]
    let settingsArray = userSettingsString.split(',')
    let defaultSettingsArray = defaultSettingsString.split(',')
    for (let i = 0; i < sizeSettings.length; i++) {
      let currentSettingsObject = sizeSettings[i]
      let value = this.getCurrentSettingValue(settingsArray, defaultSettingsArray, currentSettingsObject)
      resultOblect[currentSettingsObject.name] = this.processValue(value, currentSettingsObject)
    }
    return resultOblect
  }

  static getCurrentSettingValue(settingsArray, defaultSettingsArray, currentSettingsObject) {
    let settingAllDevices = settingsArray[currentSettingsObject.index]
    let defaultSettingAllDevices = defaultSettingsArray[currentSettingsObject.index]
    let settingAllDevicesArray = !settingAllDevices ? [ undefined ] : settingAllDevices.split('~')
    let defaultSettingAllDevicesArray = !defaultSettingAllDevices ? currentSettingsObject.defValue : defaultSettingAllDevices.split('~')
    return settingAllDevicesArray[0] == undefined || settingAllDevicesArray[0] == '' ? defaultSettingAllDevicesArray[0] : settingAllDevicesArray[0]
  }
  
  static processValue(currentValue, sizeSetting) {
    if (sizeSetting.values && sizeSetting.values.length > currentValue) {
      return  sizeSetting.values[currentValue]
    }
    return sizeSetting.defaultValue
  }
}
